var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "data-view" },
    [
      _vm._m(0),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c("el-col", { attrs: { xs: 6, sm: 6, md: 6 } }, [
            _c("div", {
              staticClass: "trade-clr",
              attrs: { id: "tradeDount" },
            }),
          ]),
          _c("el-col", { attrs: { xs: 6, sm: 6, md: 6 } }, [
            _c("div", {
              staticClass: "order-clr",
              attrs: { id: "orderDount" },
            }),
          ]),
          _c("el-col", { attrs: { xs: 12, sm: 12, md: 12 } }, [
            _c("div", { staticClass: "data-view-content" }, [
              _c("div", { staticClass: "data-view-item" }, [
                _c("div", { staticClass: "data-view-item-title" }, [
                  _vm._v("近30天买家数"),
                ]),
                _c("div", { staticClass: "data-view-item-content" }, [
                  _vm._v("线上：" + _vm._s(_vm.res.MonthBuyers.OnLine)),
                ]),
              ]),
              _c("div", { staticClass: "data-view-item" }, [
                _c("div", { staticClass: "data-view-item-title" }, [
                  _vm._v("近30天订单数"),
                ]),
                _c("div", { staticClass: "data-view-item-content" }, [
                  _vm._v("线上：" + _vm._s(_vm.res.MonthCount.OnLine)),
                ]),
              ]),
              _c("div", { staticClass: "data-view-item" }, [
                _c("div", { staticClass: "data-view-item-title" }, [
                  _vm._v("近30天客单价"),
                ]),
                _c("div", { staticClass: "data-view-item-content" }, [
                  _vm._v("线上：" + _vm._s(_vm.res.MonthUnitPrice.OnLine)),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "data-view-header" }, [
      _c("div", { staticClass: "view-title" }, [_vm._v(" 今日交易情况 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }